import React from "react";

import _ from "lodash";
import { useI18n } from "Hooks";
import Thread from "../../Thread/Thread";
import { connect } from "react-redux";
import {
  CHAT_TYPE_BE,
  getFormattedNameForUserType,
  getSubText,
} from "MessagingV2/modules/Utils";
import { STUDENT } from "Constants/stringConstants";
import { useDispatch } from "Hooks/useDispatch";
import { setMessagingUser, getUserInfo } from "Login/modules/LoginModule";
import {
  getDefaultNameSortPreference,
  getUserType,
} from "modules/CommonSelectors";

const DynamicChatSuggestions = props => {
  const { t } = useI18n();
  const dispatch = useDispatch();

  const {
    users,
    staffName,
    defaultStudentNameSortPreference,
    isPersonalChat = true,
  } = props;
  if (!isPersonalChat) {
    return _.map(users, node => {
      const { id, familyMembers } = node;
      const studentName = getFormattedNameForUserType({
        user: {
          ...node,
          type: STUDENT,
        },
        orderBy: defaultStudentNameSortPreference,
      });

      const onThreadClick = () =>
        dispatch(setMessagingUser({ id, isFamilyChannel: true }));

      if (_.isEmpty(familyMembers)) return null;

      return (
        <Thread
          id={id}
          avatarId={id}
          key={id}
          chatType={CHAT_TYPE_BE.CHANNEL_FAMILY}
          mainText={t("common:family_of_student_with_staff", {
            staffName: staffName,
            studentName: studentName,
          })}
          subText={t("common:count_members", {
            count: _.size(familyMembers) + 1,
          })}
          onlineStatus={false}
          onThreadClick={onThreadClick}
        />
      );
    });
  }

  return _.map(users, node => {
    const { id } = node;
    const userName = getFormattedNameForUserType({
      user: node,
      orderBy: defaultStudentNameSortPreference,
    });

    const onThreadClick = () =>
      dispatch(setMessagingUser({ id, isFamilyChannel: false }));

    return (
      <Thread
        id={id}
        avatarId={id}
        key={id}
        chatType={CHAT_TYPE_BE.PERSONAL}
        mainText={userName}
        subText={getSubText({
          loggedInUserRole: getUserType(),
          messagedUserObj: node,
          messagedUserRole: _.get(node, "type"),
          t,
          defaultStudentNameSortPreference,
        })}
        onlineStatus={false}
        onThreadClick={onThreadClick}
      />
    );
  });
};

const mapStateToProps = state => {
  const data = getUserInfo({ portalType: "PLANNER" });

  const staffName = getFormattedNameForUserType({
    user: {
      firstName: _.get(data, "first_name"),
      lastName: _.get(data, "last_name"),
      type: _.get(data, "user_type"),
    },
  });

  return {
    staffName,
    defaultStudentNameSortPreference: getDefaultNameSortPreference(state),
  };
};

export default connect(mapStateToProps)(DynamicChatSuggestions);
